import { render, staticRenderFns } from "./IconUpBadge.vue?vue&type=template&id=28c7b996"
import script from "./IconUpBadge.vue?vue&type=script&lang=js"
export * from "./IconUpBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports